import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getEngagementById } from "../store/slices/engagementSlice";
import { getEngagement } from "../store/services/engagement.service";

const POLLING_INTERVAL = 5000;
const COMPLETED_STEP_ID = 4;

export const useEngagementPolling = () => {
  const dispatch = useDispatch();

  const [engagementId, setEngagementId] = useState(null);
  const [engagementToken, setEngagementToken] = useState(null);
  const [apiUrl, setApiUrl] = useState(null);
  const [singleEngagementData, setSingleEngagementData] = useState(null);
  const intervalRef = useRef(null);

  const startPolling = (id, token, apiUrl) => {
    if (!id || intervalRef.current) return;
    setEngagementId(id);
    setEngagementToken(token);
    setApiUrl(apiUrl);
  };

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setEngagementId(null);
  };

  useEffect(() => {
    if (!engagementId) return;

    intervalRef.current = setInterval(async () => {
      try {
        console.log("Polling demo engagement with ID:", { 
            id: engagementId, 
            isPolling: true, 
            engagementToken: engagementToken,
            apiUrl: apiUrl 
          });
          const request = { 
            id: engagementId, 
            isPolling: true, 
            engagementToken: engagementToken,
            apiUrl: apiUrl 
          };
        
        const responseObj = await getEngagement({request});
        const response = responseObj?.data;
        
        console.log('getEngagement response', response);
        
        setSingleEngagementData(response);
        const stepId = response?.engagementSetupStepID;
        
        console.log("Polling demo engagement step:", stepId);
        console.log("Polling demo engagement sandboxEngagementStatus:", response?.sandboxEngagementStatus);  
        
        if (stepId === COMPLETED_STEP_ID || response?.sandboxEngagementStatus === 'Failed') {
          console.log("Demo engagement setup completed");
          stopPolling();
        }
      } catch (error) {
        console.error("Demo engagement polling failed:", error);
      }
    }, POLLING_INTERVAL);

    return stopPolling;
  }, [engagementId, dispatch, engagementToken, apiUrl]);

  return {
    startPolling,
    stopPolling,
    isPolling: !!intervalRef.current,
    singleEngagementData,
  };
};
